<template>
  <!-- Use the new navigation component -->
  <InpatientNav />

  <!-- Page Layout -->
  <BaseLayout
    :mainUrl="mainUrl"
    :tableSearchUrl="searchUrl"
    :searchPlaceholder="placeHolderText"
    @child-data-state-mount="handle_external_mount"
  >
    <!-- table heading -->
    <template v-slot:table-heading>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        #s/n
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Patient Name
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        OPD/IPD
      </th>
      <th
        class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2"
      >
        Requested Ward
      </th>
      <th
        class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7"
      >
        Admission Date
      </th>
      <th class="text-secondary opacity-7"></th>
    </template>

    <!-- table content -->
    <template v-slot:table-contents-place>
      <tr v-for="user in users" :key="user.id">
        <td>#{{ user.visit_id }}</td>
        <td>
          <div class="d-flex px-2 py-1">
            <div class="d-flex flex-column justify-content-center">
              <h6 class="mb-0 text-sm">{{ user.patient_name }}</h6>
              <p class="text-xs text-secondary mb-0">
                {{ user.phone == null ? "--" : user.phone }}
              </p>
            </div>
          </div>
        </td>
        <td>
          <p class="text-xs font-weight-bold mb-0">
            OPD/{{ user.opd == null ? "--" : user.opd }}
          </p>
          <p class="text-xs text-secondary mb-0">
            IPD/{{ user.ipd == null ? "--" : user.ipd }}
          </p>
        </td>
        <td>{{ user.ward_name }}</td>
        <td class="align-middle text-center text-sm">
          <soft-badge color="success" variant="gradient" size="sm">
            <!-- {{ formatDateTime_int(user.admission_date) }} -->
            {{ user.admission_date }}
          </soft-badge>
        </td>
        <td class="align-middle">
          <a @click="display_admit_modal(user.visit_id)" class="btn-service">
            Assign Bed
          </a>
        </td>
      </tr>
    </template>
  </BaseLayout>

  <AdmitModal
    v-if="show_admit_modal"
    @close-admission-modal="hide_admit_modal"
    :visit_id="current_visit_id"
  />
</template>

<script>
import BaseLayout from "../Patients/components/table_page_layout.vue";
import formatDateTime from "../../timezone/utc_local_time.js";
import InpatientNav from "./inpatient_nav.vue";
// import loader from "../special_clinics/dialysis/loader.vue";

import AdmitModal from "../visits_management/inpatient/admit_patient_modal.vue";

export default {
  name: "awaitingbedsindex",
  components: {
    BaseLayout,
    InpatientNav,
    AdmitModal,
    // loader
  },
  data() {
    return {
      current_visit_id: "",
      show_admit_modal: false,
      users: [],
      allData: {},
      apiLoading: false,
      tableLoading: true,
      placeHolderText: "Search name,phone,email,opd/ipd",
      searchUrl: "inpatient/awaiting_beds_index_search",
      mainUrl: "inpatient/awaiting_beds_index",
    };
  },
  methods: {
    display_admit_modal(visit_id) {
      this.current_visit_id = visit_id;
      this.show_admit_modal = true;
    },
    hide_admit_modal() {
      this.show_admit_modal = false;
      this.current_visit_id = "";
      window.location.reload();
    },
    handle_external_mount(payload) {
      this.users = payload;
    },
    formatDateTime_int(payload) {
      return formatDateTime(payload);
    },
  },
};
</script>

<style scoped>
.btn-service {
  border: 1px solid #16a34a;
  padding: 4px 10px;
  color: #16a34a;
  font-weight: 600;
  border-radius: 6px;
  font-size: 0.8rem;
  transition: all 0.2s ease;
}
.btn-service:hover {
  background: #16a34a;
  color: #fff;
}
</style>
